import { render, staticRenderFns } from "./MaximumUserLimitPanel.vue?vue&type=template&id=79496ed6&scoped=true"
import script from "./MaximumUserLimitPanel.vue?vue&type=script&lang=js"
export * from "./MaximumUserLimitPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79496ed6",
  null
  
)

export default component.exports